// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/delete_vision_location.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/delete_vision_location.proto.
 */
export const file_vision_projects_v1_delete_vision_location: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vcHJvamVjdHMvdjEvZGVsZXRlX3Zpc2lvbl9sb2NhdGlvbi5wcm90bxIZcHJvdG9zLnZpc2lvbi5wcm9qZWN0cy52MSKfAQobRGVsZXRlVmlzaW9uTG9jYXRpb25SZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuRGVsZXRlVmlzaW9uTG9jYXRpb25SZXF1ZXN0LlBhcmFtcxoxCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRITCgtsb2NhdGlvbl9pZBgCIAEoCSJ4ChxEZWxldGVWaXNpb25Mb2NhdGlvblJlc3BvbnNlEk4KBnJlc3VsdBgBIAEoCzI+LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuRGVsZXRlVmlzaW9uTG9jYXRpb25SZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionLocationRequest
 */
export type DeleteVisionLocationRequest = Message<"protos.vision.projects.v1.DeleteVisionLocationRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.DeleteVisionLocationRequest.Params params = 1;
   */
  params?: DeleteVisionLocationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionLocationRequest.
 * Use `create(DeleteVisionLocationRequestSchema)` to create a new message.
 */
export const DeleteVisionLocationRequestSchema: GenMessage<DeleteVisionLocationRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_location, 0);

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionLocationRequest.Params
 */
export type DeleteVisionLocationRequest_Params = Message<"protos.vision.projects.v1.DeleteVisionLocationRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string location_id = 2;
   */
  locationId: string;
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionLocationRequest.Params.
 * Use `create(DeleteVisionLocationRequest_ParamsSchema)` to create a new message.
 */
export const DeleteVisionLocationRequest_ParamsSchema: GenMessage<DeleteVisionLocationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_location, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionLocationResponse
 */
export type DeleteVisionLocationResponse = Message<"protos.vision.projects.v1.DeleteVisionLocationResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.DeleteVisionLocationResponse.Result result = 1;
   */
  result?: DeleteVisionLocationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionLocationResponse.
 * Use `create(DeleteVisionLocationResponseSchema)` to create a new message.
 */
export const DeleteVisionLocationResponseSchema: GenMessage<DeleteVisionLocationResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_location, 1);

/**
 * @generated from message protos.vision.projects.v1.DeleteVisionLocationResponse.Result
 */
export type DeleteVisionLocationResponse_Result = Message<"protos.vision.projects.v1.DeleteVisionLocationResponse.Result"> & {
};

/**
 * Describes the message protos.vision.projects.v1.DeleteVisionLocationResponse.Result.
 * Use `create(DeleteVisionLocationResponse_ResultSchema)` to create a new message.
 */
export const DeleteVisionLocationResponse_ResultSchema: GenMessage<DeleteVisionLocationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_delete_vision_location, 1, 0);

